/**
 * Cart discount code: apply/remove via Cart AJAX API + section refresh (no full-page redirect).
 * Depends on: window.routes, fetchConfig(), PUB_SUB_EVENTS, publish (theme scripts).
 */

function elinGetCartSectionsToRender() {
  const itemsEl = document.getElementById('main-cart-items');
  const footerEl = document.getElementById('main-cart-footer');
  /* This theme places #cart-icon-bubble on a header link, not the Dawn section — only bundle cart blocks we can replace. */
  return [
    {
      id: 'main-cart-items',
      section: itemsEl && itemsEl.dataset ? itemsEl.dataset.id : null,
      selector: '.js-contents',
    },
    {
      id: 'main-cart-footer',
      section: footerEl && footerEl.dataset ? footerEl.dataset.id : null,
      selector: '.js-contents',
    },
  ].filter((s) => s.section);
}

function elinUpdateHeaderCartBubble(parsed) {
  const wrap = document.getElementById('cart-icon-bubble');
  if (!wrap || typeof parsed.item_count !== 'number') return;

  let badge = wrap.querySelector('.header-custom__cart-count');
  if (parsed.item_count > 0) {
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'header-custom__cart-count';
      wrap.appendChild(badge);
    }
    badge.textContent = parsed.item_count;
    badge.hidden = false;
  } else if (badge) {
    badge.remove();
  }
}

function elinGetSectionInnerHTML(html, selector) {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const el = doc.querySelector(selector);
  return el ? el.innerHTML : '';
}

function elinReplaceCartSections(parsedState) {
  if (!parsedState || !parsedState.sections) return;

  elinGetCartSectionsToRender().forEach((sectionConfig) => {
    const html = parsedState.sections[sectionConfig.section];
    if (!html) return;

    const host =
      document.getElementById(sectionConfig.id) ||
      document.querySelector(`[data-section-id="${sectionConfig.section}"]`);
    if (!host) return;

    const elementToReplace = host.querySelector(sectionConfig.selector) || host;
    const inner = elinGetSectionInnerHTML(html, sectionConfig.selector);
    if (inner) elementToReplace.innerHTML = inner;
  });

  const cartItemsEl = document.querySelector('cart-items');
  if (cartItemsEl && typeof parsedState.item_count === 'number') {
    cartItemsEl.classList.toggle('is-empty', parsedState.item_count === 0);
  }

  const cartFooter = document.getElementById('main-cart-footer');
  if (cartFooter && typeof parsedState.item_count === 'number') {
    cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
  }

  elinUpdateHeaderCartBubble(parsedState);

  if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-discount', cartData: parsedState });
  }
}

function elinFormatDiscountMoney(cents, currencyCode) {
  if (cents == null || isNaN(cents)) return '';
  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currencyCode || 'USD',
    }).format(cents / 100);
  } catch (e) {
    return (cents / 100).toFixed(2);
  }
}

/** Normalize for case-insensitive discount code comparison (Cart AJAX uses mixed case). */
function elinNormalizeDiscountCode(value) {
  return String(value || '')
    .trim()
    .toLowerCase();
}

/**
 * True when the cart JSON shows a monetary or line-item discount effect.
 * Note: free-shipping-only codes often leave total_discount and cart_level_discount_applications at 0.
 */
function elinCartHasDiscountEffect(parsed) {
  const apps = parsed.cart_level_discount_applications || [];
  if (apps.length > 0) return true;

  const totalDiscount = parsed.total_discount != null ? Number(parsed.total_discount) : 0;
  if (!Number.isNaN(totalDiscount) && totalDiscount > 0) return true;

  const originalTotal = parsed.original_total_price != null ? Number(parsed.original_total_price) : null;
  const totalPrice = parsed.total_price != null ? Number(parsed.total_price) : null;
  if (
    originalTotal != null &&
    totalPrice != null &&
    !Number.isNaN(originalTotal) &&
    !Number.isNaN(totalPrice) &&
    originalTotal > totalPrice
  ) {
    return true;
  }

  const items = parsed.items || [];
  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    const allocations = item.line_level_discount_allocations || item.discount_allocations || [];
    if (Array.isArray(allocations) && allocations.length > 0) return true;

    const lineTd = item.total_discount != null ? Number(item.total_discount) : 0;
    if (!Number.isNaN(lineTd) && lineTd > 0) return true;

    const discounts = item.discounts;
    if (Array.isArray(discounts) && discounts.length > 0) return true;
  }

  return false;
}

/**
 * Cart AJAX returns discount_codes: [{ code, applicable }] or string entries.
 * When applicable is false (e.g. minimum not met), the code must not count as applied.
 */
function elinSubmittedDiscountCodeAccepted(parsed, submittedCode) {
  const want = elinNormalizeDiscountCode(submittedCode);
  if (!want) return false;

  const list = parsed.discount_codes;
  if (!Array.isArray(list)) return false;

  for (let i = 0; i < list.length; i++) {
    const entry = list[i];
    let codeStr = '';
    let applicable = true;

    if (typeof entry === 'string') {
      codeStr = entry;
    } else if (entry && typeof entry === 'object') {
      codeStr = entry.code != null ? String(entry.code) : '';
      if (entry.applicable === false) applicable = false;
    } else {
      continue;
    }

    if (elinNormalizeDiscountCode(codeStr) !== want) continue;
    return applicable;
  }

  return false;
}

function elinCartDiscountLooksApplied(parsed, submittedCode) {
  return elinCartHasDiscountEffect(parsed) || elinSubmittedDiscountCodeAccepted(parsed, submittedCode);
}

function elinShowCouponAlert(type, message) {
  const el = document.getElementById('elin-cart-coupon-alerts');
  if (!el) return;
  el.hidden = false;
  el.className = 'elin-cart-coupon-alerts mb-3';
  el.classList.add(type === 'success' ? 'elin-cart-coupon-alerts--success' : 'elin-cart-coupon-alerts--error');
  el.textContent = message;
}

function elinClearCouponAlert() {
  const el = document.getElementById('elin-cart-coupon-alerts');
  if (!el) return;
  el.hidden = true;
  el.textContent = '';
  el.className = 'elin-cart-coupon-alerts mb-3';
}

function elinPostCartDiscount(discountCode) {
  const sections = elinGetCartSectionsToRender().map((s) => s.section);
  const body = JSON.stringify({
    discount: discountCode,
    sections,
    sections_url: window.location.pathname,
  });

  return fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } }).then((response) =>
    response.text().then((text) => ({
      ok: response.ok,
      status: response.status,
      text,
    }))
  );
}

function elinApplyDiscountFromInput() {
  const input = document.getElementById('elin-cart-discount-code');
  const applyBtn = document.querySelector('.elin-cart-coupon__apply-btn');
  if (!input || !input.value.trim()) {
    elinShowCouponAlert('error', window.cartStrings.couponEmpty || 'Enter a discount code.');
    return;
  }

  const code = input.value.trim();
  elinClearCouponAlert();
  if (applyBtn) applyBtn.disabled = true;

  elinPostCartDiscount(code)
    .then(({ ok, status, text }) => {
      let parsed;
      try {
        parsed = JSON.parse(text);
      } catch (e) {
        elinShowCouponAlert('error', window.cartStrings.error || 'Something went wrong.');
        return;
      }

      if (!ok) {
        const msg =
          parsed.description ||
          parsed.message ||
          window.cartStrings.couponInvalid ||
          'That discount code is not valid.';
        elinShowCouponAlert('error', msg);
        return;
      }

      const apps = parsed.cart_level_discount_applications || [];
      const totalDiscountCents = parsed.total_discount != null ? parsed.total_discount : 0;
      const applied = elinCartDiscountLooksApplied(parsed, code);

      if (!applied) {
        elinShowCouponAlert(
          'error',
          window.cartStrings.couponInvalid || 'That discount code is not valid.'
        );
      } else if (totalDiscountCents > 0) {
        const saved = elinFormatDiscountMoney(totalDiscountCents, parsed.currency);
        const msg = (window.cartStrings.couponAppliedHtml || 'Discount applied. You saved [amount].').replace(
          '[amount]',
          saved
        );
        elinShowCouponAlert('success', msg);
      } else if (apps.length > 0) {
        const codes = apps.map((a) => a.title).join(', ');
        const msg = (window.cartStrings.couponAppliedCodes || 'Discount applied: [codes].').replace(
          '[codes]',
          codes
        );
        elinShowCouponAlert('success', msg);
      } else {
        const label = code;
        const msg = (window.cartStrings.couponAppliedCodes || 'Discount applied: [codes].').replace(
          '[codes]',
          label
        );
        elinShowCouponAlert('success', msg);
      }

      elinReplaceCartSections(parsed);
      input.value = '';
    })
    .catch(() => {
      elinShowCouponAlert('error', window.cartStrings.error || 'Something went wrong.');
    })
    .finally(() => {
      if (applyBtn) applyBtn.disabled = false;
    });
}

function elinRemoveAllDiscounts() {
  elinClearCouponAlert();
  elinPostCartDiscount('')
    .then(({ ok, text }) => {
      if (!ok) return;
      let parsed;
      try {
        parsed = JSON.parse(text);
      } catch (e) {
        return;
      }
      elinReplaceCartSections(parsed);
      if (window.cartStrings.couponRemoved) {
        elinShowCouponAlert('success', window.cartStrings.couponRemoved);
      }
    })
    .catch(() => {});
}

document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', (e) => {
    if (e.target.closest('.elin-cart-coupon__apply-btn')) {
      e.preventDefault();
      elinApplyDiscountFromInput();
    }
    if (e.target.closest('.elin-cart-applied-code__remove')) {
      e.preventDefault();
      elinRemoveAllDiscounts();
    }
  });

  const input = document.getElementById('elin-cart-discount-code');
  if (input) {
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        elinApplyDiscountFromInput();
      }
    });
  }
});
